import { render, staticRenderFns } from "./OrdersTableOrder.vue?vue&type=template&id=89b8ea86&"
import script from "./OrdersTableOrder.vue?vue&type=script&lang=js&"
export * from "./OrdersTableOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports